<template>
    <div class="inline">
        <my-button :loading="findingProjects" class="btn btn-line-primary rounded-full" @click="openModal">
            <span class="hidden sm:inline-block">Invite to Work</span>
        </my-button>
        <modal v-if="showModal" :modal-title="`Select a job to invite ${inviteeName} to join`" @close="showModal = false">
            <template v-slot:body>
                <div class="py-2">
                    <div v-for="project in projects" :key="project.id" class="mb-5">
                        <label class="flex items-baseline mb-1">
                            <input v-model="selectedProject" type="radio" :value="project.slug" class="mr-4" />
                            <div class="font-bold">{{ project.title }}</div>
                        </label>
                        <div style="padding-left: 29px;" class="text-gray-600 mt-2">
                            {{ project.formatted_budget }}
                        </div>
                    </div>
                </div>
            </template>
            <template v-slot:footer>
                <div class="py-1">
                    <my-button class="btn btn-primary" :loading="submitting" :disabled="selectedProject === null" @click="invite">
                        Invite
                    </my-button>
                    <my-button class="btn btn-link" @click="showModal = false">Close</my-button>
                </div>
            </template>
        </modal>
    </div>
</template>

<script>
export default {
    props: {
        inviteeName: {
            type: String,
            required: true
        },
        inviteeId: {
            type: String,
            required: true
        }
    },

    data() {
        return {
            projects: null,
            findingProjects: false,
            selectedProject: null,
            submitting: false,
            showModal: false
        };
    },

    methods: {
        async fetchProjects() {
            return await axios.get(`/api/employers/${this.authUser().id}/projects`);
        },

        openModal() {
            this.findingProjects = true;

            this.fetchProjects()
                .then(response => {
                    this.projects = response.data.data;

                    if (this.projects.length < 1) {
                        flash.error({ message: 'You have no job in posted state.' });
                        return;
                    }

                    this.showModal = true;
                })
                .finally(() => (this.findingProjects = false));
        },

        invite() {
            NProgress.inc();
            this.submitting = true;

            axios
                .post(`/api/projects/${this.selectedProject}/invite`, {
                    invitee: this.inviteeId
                })
                .then(() => flash.success())
                .finally(() => {
                    this.showModal = false;
                    this.selectedProject = null;
                    this.submitting = false;
                    NProgress.done();
                });
        }
    }
};
</script>
